import { render, staticRenderFns } from "./BussinesPlans.vue?vue&type=template&id=9361469e&"
import script from "./BussinesPlans.vue?vue&type=script&lang=js&"
export * from "./BussinesPlans.vue?vue&type=script&lang=js&"
import style0 from "./BussinesPlans.vue?vue&type=style&index=0&id=9361469e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports